import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=b95228ba&scoped=true&"
import script from "./Footerbar.vue?vue&type=script&lang=js&"
export * from "./Footerbar.vue?vue&type=script&lang=js&"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=b95228ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95228ba",
  null
  
)

export default component.exports